import { IconButton, IconButtonProps } from '@mui/material';

import { RotateCW } from '@/shared/components/icons';

interface RefetchAdornmentProps extends IconButtonProps {
  isError?: boolean;
}

const RefetchAdornment = ({
  isError = false,
  ...otherProps
}: RefetchAdornmentProps) => {
  if (!isError) {
    return null;
  }

  return (
    <IconButton
      size='small'
      aria-label='refetch'
      sx={{ p: 0.6 }}
      {...otherProps}
    >
      <RotateCW sx={{ fontSize: 18 }} />
    </IconButton>
  );
};

export default RefetchAdornment;
